import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {IconComponent} from "../../ui-elements/icon/icon.component";
import {TranslateModule} from '@ngx-translate/core';
import {FieldComponent} from '../field/field.component';

@Component({
    selector: "woa-date-field",
    templateUrl: "./date-field.component.html",
    styleUrl: "./date-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: DateFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        IconComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateFieldComponent extends AbstractField {
    public readonly autocomplete: InputSignal<"bday" | "off"> = input<"bday" | "off">();
}
